<template>
    <div class="main-page">
      <div class="p1 color-block1" :class="globalTransition">
        <div class="title">{{$t('contactPage.p1.title')}}</div>
        <div class="office">
          <p class="office-title">
            {{$t('contactPage.p1.shanghaiOffice.name')}}
          </p>
          <p class="address">
            {{$t('contactPage.p1.shanghaiOffice.area')}}<br>
            {{$t('contactPage.p1.shanghaiOffice.address')}}<br>
            {{$t('contactPage.p1.shanghaiOffice.mCode')}}</p>
          <p class="address">
            {{$t('contactPage.p1.shanghaiOffice.phone1')}}<br>
            {{$t('contactPage.p1.shanghaiOffice.phone2')}}<br>
            <a href="javascript:void(0)"><u>
              {{$t('contactPage.p1.shanghaiOffice.email')}}
            </u></a></p>
        </div>
        <div class="office"  :class="globalTransition">
          <p class="office-title">
            {{$t('contactPage.p1.guangzhouOffice.name')}}
          </p>
          <p class="address">
            {{$t('contactPage.p1.guangzhouOffice.area')}}<br>
            {{$t('contactPage.p1.guangzhouOffice.address')}}<br>
            {{$t('contactPage.p1.guangzhouOffice.mCode')}}</p>
          <p class="address">
            {{$t('contactPage.p1.guangzhouOffice.phone1')}}<br>
            {{$t('contactPage.p1.guangzhouOffice.phone2')}}<br>
            <a href="javascript:void(0)"><u>
              {{$t('contactPage.p1.guangzhouOffice.email')}}
            </u></a></p>
        </div>
      </div>
      <div class="p2 color-block3">
        <img :src="contactImg1Url" alt="DIMER"/>
        <div class="right">
          <div class="office" :class="globalTransition">
            <p class="office-title">
              {{$t('contactPage.p1.MelbourneOffice.name')}}
            </p>
            <p class="address">
              {{$t('contactPage.p1.MelbourneOffice.area')}}<br>
              {{$t('contactPage.p1.MelbourneOffice.address')}}<br>
              {{$t('contactPage.p1.MelbourneOffice.mCode')}}</p>
            <p class="address">
              {{$t('contactPage.p1.MelbourneOffice.phone1')}}<br>
              <a href="javascript:void(0)"><u>
                {{$t('contactPage.p1.MelbourneOffice.email')}}
              </u></a></p>
          </div>
        </div>
      </div>
      <div class="p3">
        <p class="title" :class="globalTransition">{{$t('contactPage.p2.title')}}</p>
        <div class="content">
          <div class="left" >
            <input v-model="form.name" :placeholder="$t('contactPage.p2.name')"
                   :class="globalTransitions?'global-i18n-hide-p':'global-i18n-not-hide-p'"/>
            <input v-model="form.email" :placeholder="$t('contactPage.p2.email')"
                   :class="globalTransitions?'global-i18n-hide-p':'global-i18n-not-hide-p'"/>
            <input v-model="form.contact" :placeholder="$t('contactPage.p2.contact')"
                   :class="globalTransitions?'global-i18n-hide-p':'global-i18n-not-hide-p'"/>
          </div>
          <div class="right">
            <div class="head" :class="globalTransition">{{$t('contactPage.p2.message')}}</div>
            <textarea v-model="form.message" class="message-input"/>
            <a :href="mailTo" rel="nofollow">
              <button class="input-btn"
               :class="globalTransition">{{$t('contactPage.p2.sendMessage')}}</button></a>
          </div>
        </div>
      </div>
      <div class="divider-div"> <el-divider class="divider"></el-divider></div>
      <div class="p4">
        <div class="font-area" :class="globalTransition">
          <div class="title">
            <p>{{$t('contactPage.p3.title')}}</p>
          </div>
          <p class="split-line">——</p>
          <div class="contents">
            <p>{{$t('contactPage.p3.content')}}</p>
          </div>
        </div>
      </div>
      <div class="p5">
        <div class="image-area" v-for="value in [2,1,3]" :key="value">
          <a :href="partnerList[value]" target="_blank">
            <img :src="computeSrc(value)" alt="DIMER"></a>
        </div>
      </div>
      <footMenu ref="wasteWaterTreat"></footMenu>
    </div>
</template>

<script>
import contactImg1 from '@/assets/contactImg1.jpg';
import footMenu from '@/components/footMenu';

export default {
  name: 'contactPage',
  components: {
    footMenu,
  },
  data() {
    return {
      contactImg1Url: contactImg1,
      partnerList: [false, 'http://www.co2crc.com.au', 'http://www.skywell-china.com', false],
      form: {
        name: '',
        email: '',
        contact: '',
        message: '',
      },
    };
  },
  computed: {
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
    globalTransitions() {
      return this.$store.getters.globalTransition;
    },
    mailTo() {
      return `mailto:info@dimer.com.au?subject=${this.form.name}&body=Name:${this.form.name}%0DEmail:${this.form.email}%0DContact:${this.form.contact}%0DMessage:${this.form.message}`;
    },
  },
  methods: {
    computeSrc(value) {
      // eslint-disable-next-line
      return require(`../../assets/globalPartner/logo${value}.jpg`);
    },
  },
};
</script>

<style lang="scss" scoped>
 .main-page{
   .p1{
     display: flex;
     padding-top: 8rem;
    margin-left: 6.7%;
     .title{
       font-size: 4rem;
       width: 30%;
       font-weight: bold;
     }
     .office{
       p{
         margin-block-start: 0!important;
       }
        width: 30%;
       .office-title{
         font-size: 1.4rem;
         line-height: 2rem;
         font-weight: bold;
       }
       .address{
        font-size: 1.1rem;
         line-height: 1.8rem;
         max-width: 80%;
       }
     }
   }
   .p2{
     display: flex;
     padding: 5% 6.7%;
     img{
      height: 60%;
       width: 60%;
     }
     .right{
       display: flex;
       flex-direction: column;
       padding-left: 6rem;
       justify-content: center;
       width: 40%;
     }
     .office{
       .office-title{
         font-size: 2.4rem;
         line-height: 4rem;
         font-weight: bold;
       }
       .address{

         font-size: 1.5rem;
         line-height: 2.4rem;
       }
     }
   }
   .p3{
     padding: 20px 6.7%;
     .title{
       font-size: 2rem;
       text-align: center;
       font-weight: bold;
     }
     .content{
       width: 100%;
       padding: 5rem 0;
       background-color: #309efd;
       display: flex;
       flex-direction: row;
       justify-content: space-around;
       input,textarea{
         width: 80%;
         color: #fff;
         background-color: transparent;
         border: #fff 2px solid;
         display: block;
         color: #fff;
         border-image: none;
       }
       input{
         margin-top: 2rem;
         height: 3rem;
         font-size: 1.4rem;
         border-left: none;
         border-top: none;
         border-right: none;
       }
       textarea{
         margin-top: 0rem;
         height: 10rem;
         font-size: 1rem;
         border:none;
       }
       input:focus{
         outline: none;
       }
       textarea:focus{
         outline: none;
       }
       input::placeholder{
         color: #fff;
         font-size: 1.4rem;
         font-weight: bold;
         margin-block-end: 0px;
       }
       .left{
         width: 40%;
       }
       .right{
         width: 40%;
         .head{
           color: #fff;
           font-size: 1.4rem;
           font-weight: bold;
           margin-top: 2rem;
           height: 3rem;
           color: #fff;
         }
         .message-input{
         }
         .input-btn{
           cursor: pointer;
           height: 4rem;
           margin-top: 3rem;
           width: 18rem;
           color: #fff;
           font-size: 1.4rem;
           font-weight: bold;
           background-color: transparent;
           color: #fff;
           border: #fff 2px solid;
         }
         input-btn:focus{
           outline: none!important;
         }
       }

     }
   }
 }
 .p4{
   display: flex;
   flex-direction: column;
   align-items: center;
   background-color: #fff;
   padding:0px 10.5%;
   text-align: center;

 }
 .font-area{
   width: 70%;
   .title{
     font-size: 2rem;
     font-weight: bold;
   }
   .contents{
     font-size: 1.1rem;
     line-height: 2rem;
     white-space: nowrap;
   }
 }
  .p5{
    display: flex;
    padding: 0 10rem 5rem 10rem;
    justify-content: space-around;
    .image-area{
      img{
        width: 54%;
        margin-left: 23%;
      }
    }
  }
 .color-block1{
   background-size: 13rem;
   background-position-x: 95%;
   background-position-y: 90%;
   background-repeat: no-repeat;
   background-image:url("../../assets/color-block.png");
 }
 .color-block2{
   background-size: 160px;
   background-position-x: calc(80% + 48px);
   background-position-y:100%;
   background-repeat: no-repeat;
   background-image:url("../../assets/color-block.png");
 }
 .color-block3{
   padding-bottom: 6.7rem;
   background-image:url("../../assets/color-block.png"),url("../../assets/color-block.png");
   background-size: 11vw,30vw;
   background-position: 58% 98%,0% 0%;
   background-repeat: no-repeat,no-repeat;
 }
</style>



// WEBPACK FOOTER //
// src/views/contactPage/index.vue